import React, { FC, useState } from "react";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { formatDateAndTimeFromString } from "../../utils/date-setup";
import { ReplyDataProps } from "../../interface/account";
import { TypographyAccountContent } from "../ui-elements/typography-content";

const AccountComment: FC<{ data: ReplyDataProps }> = ({ data }) => {
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <Box
      sx={{
        minHeight: 80,
        my: 1,
        mx: 3,
        padding: isMedium ? 1 : 2,
        borderBottom: "1px solid rgb(231, 235, 239)",
      }}
    >
      {/* Comment Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 2,
        }}
      >
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <img
            src={data?.author_photo_url}
            alt="Author"
            style={{ width: 30, height: 30, borderRadius: "50%" }}
          />
          <Stack>
            <Typography variant="subtitle2" color="black">
              {data?.author_name}
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          mx: 3,
          px: 2,
          border: "1px solid #ccc",
          borderRadius: 2,
        }}
      >
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <img
            src={data?.commented_entity?.author_photo_url}
            alt="Author"
            style={{ width: 30, height: 30, borderRadius: "50%" }}
          />
          <Stack>
            <Typography variant="subtitle2" color="black">
              {data?.commented_entity?.author_name}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "#4A5E6D", fontWeight: 400 }}
            >
              {formatDateAndTimeFromString(data?.commented_entity?.created_at)}
            </Typography>
          </Stack>
        </Stack>
        <Divider sx={{ mt: 1 }} />
        <Typography variant="body2" sx={{ fontWeight: 500, py: 2 }}>
          {data?.commented_entity?.title}
        </Typography>
      </Box>

      {/* Comment Body */}
      <Box sx={{}}>
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          Your comment:
        </Typography>
        <Typography variant="body2" sx={{}}>
          {data?.comment}
        </Typography>
      </Box>
    </Box>
  );
};

export default AccountComment;
